import { useState } from 'react';
import './BookingsAvailableBanner.css';

export default function BookingsAvailableBanner() {
  const [isDismissed, setIsDismissed] = useState(() => {
    return localStorage.getItem('bookings-banner-dismissed') === 'true';
  });

  if (isDismissed) return null;

  const handleDismiss = () => {
    setIsDismissed(true);
    localStorage.setItem('bookings-banner-dismissed', 'true');
  };

  return (
    <div className="bookings-banner">
      <div className="bookings-banner__content">
        <div className="bookings-banner__icon">📅</div>
        <div className="bookings-banner__text">
          <h3>Bookings is now available on all plans!</h3>
          <p>Manage appointments and scheduling with your customers at no extra cost.</p>
        </div>
        <button
          className="bookings-banner__cta"
          onClick={() => window.location.href = '/?view=bookings'}
        >
          Explore Bookings
        </button>
      </div>
      <button
        className="bookings-banner__close"
        onClick={handleDismiss}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
